/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('banner.video', function (el) {
        var playButton = el.querySelector('button.play');
        var iframe = el.querySelector('iframe');
        if (!playButton || !iframe) {
            return;
        }
        playButton.addEventListener('click', function (e) {
            el.classList.add('playing');
            iframe.setAttribute('src', iframe.getAttribute('src') + '&autoplay=1');
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
